import React from 'react';
import { Link } from 'react-router-dom';

const quickActions = [
  {
    title: 'Main',
    description: '홈으로 이동',
    to: '/',
  },
  {
    title: 'Sign Up',
    description: 'Binance 계정 연동 시작',
    to: '/SignupAtsBinance',
  },
  {
    title: 'Log In',
    description: '나의 전략 이어가기',
    to: '/LoginAtsBinance',
  },
  {
    title: 'Auto Trade',
    description: 'Binance 전략 페이지로',
    to: '/SelectPageBinance',
  },
];

const highlights = [
  '거래환경 별 슬리피지 제어 옵션',
  '멀티 심볼 진입/대기 리스트 관리',
  '모바일 퀵패널로 즉시 정지/재개',
];

const SelectBinance = () => {
    return (
    <div className="exchange-landing exchange-landing--binance">
      <span className="exchange-landing__overlay" />

      <div className="exchange-landing__content exchange-landing__content--single">
        <section className="exchange-landing__hero">
          <p className="exchange-badge exchange-badge--binance">Binance Suite</p>
          <h1>
            Binance 특화 전략 센터<br />
            빠른 시세에도 안정적으로.
          </h1>
          <p className="exchange-hero__subtitle">
            변동성이 큰 알트마켓에서도 원하는 비중과 리스크를 유지하도록 설계된 Bitgenstone Binance 자동매매 콘솔입니다.
          </p>

          <ul className="exchange-highlight-list">
            {highlights.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          <div className="exchange-actions">
            {quickActions.map((action) => (
              <Link to={action.to} className="exchange-action-card" key={action.title}>
                <div>
                  <p className="exchange-action__title">{action.title}</p>
                  <p className="exchange-action__desc">{action.description}</p>
                </div>
                <span aria-hidden="true">→</span>
              </Link>
            ))}
          </div>

          <p className="exchange-hero__hint">
            모든 버튼은 모바일 화면에서도 동일한 크기로 재배치되어 사용자가 더욱 편리하게 전략을 관리할 수 있습니다.                     
          </p>
        </section>

        {/* <section className="exchange-landing__panel">
          <div className="exchange-panel-card">
            <p className="exchange-panel__label">BingX Essentials</p>
            <h3>자동화 전략 & 리스크 컨트롤</h3>
            <p className="exchange-panel__subtitle">
              Copy Trading, Hedge, Ultra 등 다양한 프리셋을 기반으로 나만의 기준을 더해 복합 전략을 구성할 수 있습니다.
            </p>

            <div className="exchange-panel__stats">
              <article>
                <span className="stat-label">지원 마켓</span>
                <strong>Perp · Spot</strong>
              </article>
              <article>
                <span className="stat-label">실시간 감지</span>
                <strong>1200+ 시그널</strong>
              </article>
              <article>
                <span className="stat-label">긴급 기능</span>
                <strong>Stop · Hedge</strong>
              </article>
            </div>

            <div className="exchange-panel__footer">
              <div>
                <p className="exchange-panel__mini">권장 전략</p>
                <p className="exchange-panel__mini-desc">Hedge BingX · WZ · Meme</p>
              </div>
              <div className="exchange-panel__tags">
                <span>BingX</span>
                <span>USDT</span>
                <span>Auto</span>
              </div>
            </div>
          </div>
        </section> */}
            </div>
        </div>
    );
};

export default SelectBinance;
